import React from 'react';

const ErrorMessage: React.FC = ({ children }) => (
  <div className=" text-red-600 text-sm italic">{children}</div>
);

export default ErrorMessage;
